module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("总共")]), _vm._v(" "), (!!_vm.rightText) ? _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.rightText))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7234b06f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/item-total-price.vue
// module id = 867
// module chunks = 34